import React from 'react';
import TextAreaLabelOptionalBase, {
    ITextAreaProps,
} from './text-area-label-optional-base';

const TextAreaLabelOptional = ({
    name,
    onChange,
    className,
    maxLength,
    placeholder,
    value,
    title,
    error,
    showError,
    required,
    onBlur,
}: ITextAreaProps) => {
    return (
        <TextAreaLabelOptionalBase
            type="text"
            name={name}
            className={className}
            onChange={onChange}
            value={value || ''}
            title={title}
            placeholder={placeholder}
            maxLength={maxLength}
            required={required}
            error={error}
            showError={showError}
            onBlur={onBlur}
        />
    );
};

export default TextAreaLabelOptional;
